import React from 'react';

interface SlideContainerProps {
  slideId: number;
  isCurrentSlide: boolean;
  isAbove: boolean;
  isBelow: boolean;
  isLocked: boolean;
  isUnlocking?: boolean;
  zIndex?: number;
  children: React.ReactNode;
}

export const SlideContainer: React.FC<SlideContainerProps> = ({
  slideId,
  isCurrentSlide,
  isAbove,
  isBelow,
  isLocked,
  isUnlocking = false,
  zIndex,
  children,
}) => {
  const getSlideClasses = () => {
    const classes = ['slide-container'];

    if (isLocked) {
      classes.push('locked');
    } else if (isUnlocking) {
      classes.push('unlocking');
    }

    if (isCurrentSlide) {
      classes.push('current');
    } else if (isBelow) {
      classes.push('below');
    } else if (isAbove) {
      classes.push('above');
    }

    return classes.join(' ');
  };

  const classes = getSlideClasses();

  return (
    <div
      className={classes}
      data-slide-id={slideId}
      style={{ zIndex }}
    >
      {children}
    </div>
  );
};
